import Reveal from "./Reveal";

import logo1 from "../../../Assets/Home/logo1.svg";
import logo2 from "../../../Assets/Home/logo2.svg";
import logo3 from "../../../Assets/Home/logo3.svg";
import logo4 from "../../../Assets/Home/logo4.svg";
import logo5 from "../../../Assets/Home/logo5.svg";
import logo6 from "../../../Assets/Home/logo6.svg";
import logo7 from "../../../Assets/Home/logo7.svg";
import logo8 from "../../../Assets/Home/logo8.svg";

export default function Partnerships() {
  const partners = [
    { id: 1, logo: logo1 },
    { id: 2, logo: logo2 },
    { id: 3, logo: logo3 },
    { id: 4, logo: logo4 },
    { id: 5, logo: logo5 },
    { id: 6, logo: logo6 },
    { id: 7, logo: logo7 },
    { id: 8, logo: logo8 },
  ];

  const allPartners = [...partners, ...partners, ...partners];

  return (
    <section className="w-full py-12 md:py-16 lg:py-20 px-4 md:px-10 lg:px-16 bg-[#041122]">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <Reveal className="text-center mb-10">
          <span className="text-xs font-semibold tracking-[0.25em] uppercase text-[#B3129E]">
            [ STRATEGIC PARTNERS ]
          </span>

          <h2 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl tracking-wider text-white font-semibold font-heading leading-relaxed mt-3">
            Built on a Network of Trust
          </h2>
        </Reveal>

        {/* Logo Carousel */}
        <div className="relative w-full overflow-hidden">
          {/* Left Fade */}
          <div className="absolute left-0 top-0 bottom-0 w-28 bg-gradient-to-r from-[#041122] to-transparent z-10 pointer-events-none" />

          {/* Right Fade */}
          <div className="absolute right-0 top-0 bottom-0 w-28 bg-gradient-to-l from-[#041122] to-transparent z-10 pointer-events-none" />

          {/* Track */}
          <div className="flex gap-12 w-max animate-scroll px-10 hover:[animation-play-state:paused]">
            {allPartners.map((p, i) => (
              <div
                key={`${p.id}-${i}`}
                className="flex items-center py-2 justify-center w-[150px] h-[96px] bg-white rounded-2xl shadow-sm hover:shadow-[0_8px_24px_rgba(0,0,0,0.15)] transition-all duration-300 flex-shrink-0"
              >
                <img
                  src={p.logo}
                  alt="partner-logo"
                  className="h-full object-contain"
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Animation */}
      <style>
        {`
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.333%); }
        }

        .animate-scroll {
          animation: scroll 26s linear infinite;
        }
        `}
      </style>
    </section>
  );
}
// import Reveal from "./Reveal";

// const partners = [
//   "NavIC",
//   "ERP",
//   "QCI",
//   "KYB Conmat",
//   "MYCO",
//   "OpenAI",
//   "RMC Certified",
//   "Tata Motors",
//   "Ashok Leyland",
//   "Schwing Stetter",
//   "Aquarius",
// ];

// const Partnerships = () => (
//   <section
//     className="w-full py-16 md:py-20 px-6 md:px-10 lg:px-16"
//     style={{ background: "#041122" }}
//   >
//     <div className="max-w-7xl mx-auto text-center">
//       <Reveal>
//         <span className="text-xs font-semibold tracking-[0.25em] uppercase text-[#B3129E]">
//           [ STRATEGIC PARTNERSHIPS ]
//         </span>
//         <h2
//           className="font-heading font-semibold text-white mt-3 mb-10 leading-snug"
//           style={{ fontSize: "clamp(1.4rem,3vw,2.4rem)" }}
//         >
//           Built on a Network of Trust
//         </h2>
//       </Reveal>

//       <Reveal delay={100}>
//         <div className="flex flex-wrap gap-3 justify-center">
//           {partners.map((p, i) => (
//             <div
//               key={p}
//               className="rounded-xl px-5 py-3 text-sm font-medium cursor-default"
//               style={{
//                 background: "#ffffff08",
//                 border: "1px solid #ffffff10",
//                 color: "#ddd",
//                 transition: "all 0.2s",
//                 animationDelay: `${i * 60}ms`,
//               }}
//               onMouseEnter={(e) => {
//                 e.currentTarget.style.background = "#B3129E22";
//                 e.currentTarget.style.borderColor = "#B3129E66";
//                 e.currentTarget.style.color = "#e8a0f0";
//               }}
//               onMouseLeave={(e) => {
//                 e.currentTarget.style.background = "#ffffff08";
//                 e.currentTarget.style.borderColor = "#ffffff10";
//                 e.currentTarget.style.color = "#ddd";
//               }}
//             >
//               {p}
//             </div>
//           ))}
//         </div>
//       </Reveal>
//     </div>
//   </section>
// );
// export default Partnerships;
